// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floatingDate {
  background-color: #fff;
  color: #000;

  height: 50px;
  position: absolute;
  right: 7px;
  text-align: center;
  top: 7px;
  width: 50px;
}

.floatingDate .month {
  background-color: #f00;
  color: #fff;
  font-size: 14px;
  width: 100%;
}

.floatingDate .month.green {
  background-color: #0f0;
}

.floatingDate .day {
  font-size: 22px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/date.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;;EAEX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".floatingDate {\n  background-color: #fff;\n  color: #000;\n\n  height: 50px;\n  position: absolute;\n  right: 7px;\n  text-align: center;\n  top: 7px;\n  width: 50px;\n}\n\n.floatingDate .month {\n  background-color: #f00;\n  color: #fff;\n  font-size: 14px;\n  width: 100%;\n}\n\n.floatingDate .month.green {\n  background-color: #0f0;\n}\n\n.floatingDate .day {\n  font-size: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
